module.exports = __webpack_public_path__ + "/bundle/asset/admission4-2-6f55eeff406fcc38a13ec5b3f7283a97.png";